module.exports = __webpack_public_path__ + "2216c24ae20ca494aeb69db0c0083bfb.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/IL.svg
// module id = yYnu
// module chunks = 0